import React, { useEffect } from "react";
import { Modal, Form, Input, InputNumber } from "antd";

export interface KitchenGroup {
  id: string;
  name: string;
  display_order: number;
}

interface KitchenGroupFormModalProps {
  visible: boolean;
  editingGroup: KitchenGroup | null;
  onCancel: () => void;
  onOk: (values: any) => void;
}

const KitchenGroupFormModal: React.FC<KitchenGroupFormModalProps> = ({
  visible,
  editingGroup,
  onCancel,
  onOk,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (visible) {
      if (editingGroup) {
        form.setFieldsValue(editingGroup);
      } else {
        form.resetFields();
        form.setFieldsValue({ display_order: 0 });
      }
    }
  }, [visible, editingGroup, form]);

  return (
    <Modal
      title={editingGroup ? "Edit Kitchen Group" : "Add Kitchen Group"}
      open={visible}
      onCancel={onCancel}
      onOk={() => form.submit()}
      destroyOnClose
    >
      <Form form={form} layout="vertical" onFinish={onOk}>
        <Form.Item
          name="name"
          label="Group Name"
          rules={[{ required: true, message: "Group name is required" }]}
        >
          <Input placeholder="e.g. Hot Kitchen" />
        </Form.Item>
        <Form.Item name="display_order" label="Display Order" initialValue={0}>
          <InputNumber min={0} style={{ width: "100%" }} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default KitchenGroupFormModal;
